'use strict';

require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');

import React from 'react';
import Slick from 'react-slick';
import IconButton from 'components/clarity-ui/inputs/iconButton';
import VideoBoxItems from './videoBoxItems2.component';
import _ from 'lodash';

class VideoResults extends React.Component {

  getThumbnail (boxGroup, handlers, aux) {
    return (
      <VideoBoxItems
        key={'vbi_'+aux}
        {...handlers}
        boxGroup={boxGroup}/>
    );
  }

  getThumbnailSection (index, slideItems) {
    return (
      <div key={'thboxslide_'+index}>{ slideItems }</div>
    );
  }

  renderThumbnails () {
    const { boxDetectorResults, ...handlers } = this.props;

    const keys = _.keys(boxDetectorResults);
    const thumbnails = [];
    var aux = 0;
    while (aux < keys.length) {
      const slideItems = [];
      slideItems.push(this.getThumbnail(boxDetectorResults[keys[aux++]], handlers, aux));
      if (aux >= keys.length) { thumbnails.push(this.getThumbnailSection(slideItems)); break; }
      slideItems.push(this.getThumbnail(boxDetectorResults[keys[aux++]], handlers, aux));
      if (aux >= keys.length) { thumbnails.push(this.getThumbnailSection(slideItems)); break; }
      slideItems.push(this.getThumbnail(boxDetectorResults[keys[aux++]], handlers, aux));
      thumbnails.push(this.getThumbnailSection(aux, slideItems));
    }
    return thumbnails;
  }

  getSlickSettings () {
    return {
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      nextArrow: <IconButton onClick={_.noop()} additionalClassName="SliderIconButtonNext" iconClass="chevronRight" />,
      prevArrow: <IconButton onClick={_.noop()} additionalClassName="SliderIconButtonPrev" iconClass="chevronLeft" />
    };
  }

  render () {
    return (
      <div>
        <Slick {...this.getSlickSettings()}>
          { this.renderThumbnails() }
        </Slick>
      </div>
    );
  }
}

export default VideoResults;



// WEBPACK FOOTER //
// ./src/components/classifier/classifierTargets/targetResults/boxResults/boxResults.component.jsx